export default {
      id: "icon-bool-difference-usage",
      viewBox: "0 0 17 15",
      url: "/" + "assets/sprite.svg#icon-bool-difference",
      toString: function () {
        return this.url;
      }
    }